import React from 'react';
import { Flex, Text, Tag, TagLeftIcon, TagLabel, Tooltip, useColorModeValue } from '@chakra-ui/react';
import {
  LuHeading1, LuHeading2, LuHeading3, LuList, LuListOrdered, LuListChecks,
  LuTable, LuImage, LuQuote, LuCode, LuMinus, LuYoutube, LuFileCode,
} from 'react-icons/lu';

export const WIKI_BLOCK_MIME = 'application/x-wiki-block';

const BLOCKS = [
  { type: 'h1', label: 'Título 1', icon: LuHeading1 },
  { type: 'h2', label: 'Título 2', icon: LuHeading2 },
  { type: 'h3', label: 'Título 3', icon: LuHeading3 },
  { type: 'bullet', label: 'Lista', icon: LuList },
  { type: 'ordered', label: 'Numerada', icon: LuListOrdered },
  { type: 'task', label: 'Checklist', icon: LuListChecks },
  { type: 'table', label: 'Tabela', icon: LuTable },
  { type: 'image', label: 'Imagem', icon: LuImage },
  { type: 'youtube', label: 'YouTube', icon: LuYoutube },
  { type: 'quote', label: 'Citação', icon: LuQuote },
  { type: 'code', label: 'Código', icon: LuCode },
  { type: 'html', label: 'HTML', icon: LuFileCode },
  { type: 'hr', label: 'Separador', icon: LuMinus },
];

export const insertWikiBlock = (editor, type, pos = null) => {
  if (!editor) return;
  const chain = pos !== null && pos !== undefined ? editor.chain().focus(pos) : editor.chain().focus();

  switch (type) {
    case 'h1':
    case 'h2':
    case 'h3':
      chain.insertContent({ type: 'heading', attrs: { level: Number(type[1]) } }).run();
      break;
    case 'bullet':
      chain.insertContent({ type: 'bulletList', content: [{ type: 'listItem', content: [{ type: 'paragraph' }] }] }).run();
      break;
    case 'ordered':
      chain.insertContent({ type: 'orderedList', content: [{ type: 'listItem', content: [{ type: 'paragraph' }] }] }).run();
      break;
    case 'task':
      chain.insertContent({ type: 'taskList', content: [{ type: 'taskItem', attrs: { checked: false }, content: [{ type: 'paragraph' }] }] }).run();
      break;
    case 'table':
      chain.insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run();
      break;
    case 'image':
      chain.run();
      editor.wikiRequestImage?.();
      break;
    case 'youtube':
      chain.run();
      editor.wikiRequestYoutube?.();
      break;
    case 'quote':
      chain.insertContent({ type: 'blockquote', content: [{ type: 'paragraph' }] }).run();
      break;
    case 'code':
      chain.insertContent({ type: 'codeBlock' }).run();
      break;
    case 'html':
      chain.insertHtmlBlock().run();
      break;
    case 'hr':
      chain.setHorizontalRule().run();
      break;
    default:
      break;
  }
};

const BlockPalette = ({ editor }) => {
  const chipBg = useColorModeValue('white', 'gray.800');
  const chipHover = useColorModeValue('orange.50', 'whiteAlpha.200');
  const labelColor = useColorModeValue('gray.400', 'gray.500');

  return (
    <Flex wrap="wrap" gap={1} align="center" px={2} py={1.5}>
      <Text fontSize="10px" fontWeight="bold" textTransform="uppercase" color={labelColor} mr={1}>
        Blocos
      </Text>
      {BLOCKS.map((b) => (
        <Tooltip key={b.type} label="Arraste para o documento ou clique para inserir" fontSize="xs" openDelay={600}>
          <Tag
            size="sm"
            variant="outline"
            bg={chipBg}
            data-wiki-block={b.type}
            cursor="grab"
            userSelect="none"
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData(WIKI_BLOCK_MIME, b.type);
              e.dataTransfer.effectAllowed = 'copy';
            }}
            onClick={() => insertWikiBlock(editor, b.type)}
            _hover={{ bg: chipHover, borderColor: 'orange.300' }}
            _active={{ cursor: 'grabbing' }}
            transition="all 0.15s"
          >
            <TagLeftIcon as={b.icon} boxSize="12px" />
            <TagLabel fontSize="xs">{b.label}</TagLabel>
          </Tag>
        </Tooltip>
      ))}
    </Flex>
  );
};

export default BlockPalette;
